import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { color } from 'chart.js/helpers';
import { colors } from '@mui/material';

export default function Chart8() {
  return (
    <BarChart
      {...props}
      series={[
        {
          data: [24, 13, 98,11,11,22,23],
          label: '',
        },
      ]}
    />
  );
}

const props = {
  width: 500,
  height: 300,
  
  xAxis: [{ data: ['ش', 'ی', 'د','س','چ','پ','ج'], scaleType: 'band' }],
};